import React from 'react';
import {Trans} from 'react-i18next';
import ElevatedButton from '../../../../components/formik/ElevatedButton';

export default function StatusNote({status, handleRefresh}) {
  switch (status) {
    case 'Previewing':
      return (
        <div className="note note-warning">
          <div className="note-close">
            <div className="close" style={{fontSize: '1rem', opacity: 1}}>
              <ElevatedButton
                type="refresh"
                onClick={() => {
                  handleRefresh();
                }}
              />
            </div>
          </div>
          <div>
            <Trans i18nKey="p.s.uiconfiguration.status.previewing">
              App preview is being generated. This may take a few minutes,
              please wait…
            </Trans>
          </div>
        </div>
      );
    case 'Publishing':
      return (
        <div className="note note-warning">
          <div className="note-close">
            <div className="close" style={{fontSize: '1rem', opacity: 1}}>
              <ElevatedButton
                type="refresh"
                onClick={() => {
                  handleRefresh();
                }}
              />
            </div>
          </div>
          <div>
            <Trans i18nKey="p.s.uiconfiguration.status.publishing">
              Your changes are being published. This may take a few minutes,
              please wait…
            </Trans>
          </div>
        </div>
      );
    case 'PreviewFailed':
      return (
        <div className="note note-danger">
          <div>
            <Trans i18nKey="p.s.uiconfiguration.status.previewfailed">
              Something went wrong while generating the app preview. Please
              click "Generate App Preview" to try again.
            </Trans>
          </div>
        </div>
      );
    case 'PublishFailed':
      return (
        <div className="note note-danger">
          <div>
            <Trans i18nKey="p.s.uiconfiguration.status.publishfailed">
              Something went wrong while publishing. Please click “Publish “to
              Online to try again.
            </Trans>
          </div>
        </div>
      );
    default:
      return <div />;
  }
}
